import { render, staticRenderFns } from "./SkillList.vue?vue&type=template&id=5993bf24"
import script from "@/controllers/custom/skill/skill-list.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/skill/skill-list.js?vue&type=script&lang=js&external"
import style0 from "./SkillList.vue?vue&type=style&index=0&id=5993bf24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports